export default "__VITE_ASSET__ByafuSPP__"